import { render } from "./UserChips.vue?vue&type=template&id=546ecada&scoped=true"
import script from "./UserChips.vue?vue&type=script&lang=js"
export * from "./UserChips.vue?vue&type=script&lang=js"

import "./UserChips.vue?vue&type=style&index=0&id=546ecada&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546ecada"]])

export default __exports__